import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import ProfileAccountSettings from './ProfileAccountSettings.js';
import { actions } from './ProfileAccountSettings.actions';
import {
    getCurrencies
} from './ProfileAccountSettings.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    currenciesList: getCurrencies
});

const ProfileAccountSettingsComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            currency: state.user?.publisher?.account?.balance?.currency || 'USD',
            balanceAmount: state.user?.publisher?.account?.balance.amount,
            rates: state.currency.rates
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            convertCurrentCurrency: actions.convertCurrentCurrency
        };
    }
)(ProfileAccountSettings);

export default ProfileAccountSettingsComponent;
